import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
    name: 'user',
    initialState: {
        value: null,
        language: 'en',
        settings: {},
    },
    reducers: {
        setUser: (state, action) => {
            state.value = action.payload
        },
        logout: (state) => {
            localStorage.removeItem('token')
            state.value = null
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setSettings: (state, action) => {
            state.settings = action.payload;
        },
    }
})

export const { setUser, logout, setLanguage, setSettings } = authSlice.actions

export default authSlice.reducer;